import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";

import * as MarketReducer from "containers/CommunityMarket/MarketReducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";

import styles from "./style.module.css";
import { Button } from "aible";

import ResetIcon from "images/arrow-rotate-left-sharp-purple.svg";

// import marketReducer from "containers/Market/MarketReducer";

const MarketFiltersPanel = (props) => {
  const {} = props;

  const dispatch = useDispatch();

  const filterOptions = useSelector((state) => MarketReducer.getFilterOptions(state));

  const priceFilter = useSelector((state) => MarketReducer.getPriceFilter(state));
  const updatePriceFilter = (priceObj) => dispatch(MarketReducer.updatePriceFilter(priceObj));
  const typeFilters = useSelector((state) => MarketReducer.getTypeFilters(state));
  const updateTypeFilters = (array) => dispatch(MarketReducer.updateTypeFilters(array));
  const metadataFilters = useSelector((state) => MarketReducer.getMetadataFilters(state));
  const updateMetadataFilters = (array) => dispatch(MarketReducer.updateMetadataFilters(array));

  const resetFilters = () => dispatch(MarketReducer.resetAllFilters());

  return (
    <div className={styles.filterContainer}>
      <Button
        onClick={() => {
          resetFilters();
        }}
        style={{ marginBottom: "20px" }}
      >
        <img className={styles.resetButtonIcon} src={ResetIcon} />
        {"Reset Filters"}
      </Button>
      {filterOptions?.map((filter) => {
        return (
          <React.Fragment>
            {filter?.category === "tool" ? (
              <div key={filter?.category} className={styles.filterCategoryWrapper}>
                <div className={styles.filterCategoryLabel}>{filter?.category}</div>
                {filter?.options?.map((o) => {
                  return (
                    <div
                      key={filter?.option + "__" + o?.label}
                      className={styles.filterCategoryOption}
                      onClick={() => {
                        if (typeFilters?.includes(o.value)) {
                          const retTypes = typeFilters.filter((filter) => filter !== o.value);
                          return updateTypeFilters(retTypes);
                        }

                        const retTypes = [...typeFilters, o.value];
                        return updateTypeFilters(retTypes);
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={typeFilters?.includes(o.value)}
                        className={styles.filterCheckRadioInput}
                        readOnly
                      />
                      {o?.label}
                    </div>
                  );
                })}
              </div>
            ) : (
              <div key={filter?.category} className={styles.filterCategoryWrapper}>
                <div className={styles.filterCategoryLabel}>{filter?.category}</div>
                {filter?.options?.map((o) => {
                  return (
                    <div
                      key={filter?.option + "__" + o?.label}
                      className={styles.filterCategoryOption}
                      onClick={() => {
                        if (metadataFilters?.includes(o.value)) {
                          const retTypes = metadataFilters.filter((filter) => filter !== o.value);
                          return updateMetadataFilters(retTypes);
                        }

                        const retTypes = [...metadataFilters, o.value];
                        return updateMetadataFilters(retTypes);
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={metadataFilters?.includes(o.value)}
                        className={styles.filterCheckRadioInput}
                        readOnly
                      />
                      {o?.label}
                    </div>
                  );
                })}
              </div>
            )}
          </React.Fragment>
        );
      })}
      <div className={styles.filterCategoryWrapper}>
        <div className={styles.filterCategoryLabel}>{"Price"}</div>
        <div
          className={styles.filterCategoryOption}
          onClick={() => {
            const retPrice = {
              ...priceFilter,
              free: !priceFilter?.free
            };
            return updatePriceFilter(retPrice);
          }}
        >
          <input
            type="checkbox"
            checked={priceFilter?.free === true}
            className={styles.filterCheckRadioInput}
            readOnly
          />
          {"FREE"}
        </div>
        <div className={styles.filterCategoryOption}>
          <div className={styles.filterPriceLabel}>{"Min: "}</div>
          <LineInput
            value={priceFilter.min !== undefined ? priceFilter.min : ""}
            placeholder={"Minimum Price"}
            updateInstant
            onChange={(val) => {
              if (val?.length < 1 || isNaN(Number(val))) {
                const retPrice = {
                  ...priceFilter,
                  min: undefined
                };
                return updatePriceFilter(retPrice);
              }

              const retPrice = {
                ...priceFilter,
                min: Number(val)
              };
              return updatePriceFilter(retPrice);
            }}
          />
        </div>
        <div className={styles.filterCategoryOption}>
          <div className={styles.filterPriceLabel}>{"Max: "}</div>
          <LineInput
            value={priceFilter.max !== undefined ? priceFilter.max : ""}
            placeholder={"Maximum Price"}
            updateInstant
            onChange={(val) => {
              if (val?.length < 1 || isNaN(Number(val))) {
                const retPrice = {
                  ...priceFilter,
                  max: undefined
                };
                return updatePriceFilter(retPrice);
              }

              const retPrice = {
                ...priceFilter,
                max: Number(val)
              };
              return updatePriceFilter(retPrice);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MarketFiltersPanel;
